import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Stack,
} from '@mui/material'
import AppDialogTitle from 'components/Dialog/AppDialogTitle'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { SET_RELOAD_BROWSER_DIALOG_STATUS } from 'store/reducers/ui/reloadDialog.reducer'
import { useAppSelector } from 'store/useStoreHook'

function ReloadBrowserDialog() {
    const dispatch = useDispatch()
    const open = useAppSelector((state) => state.ui.reloadDialog.open)

    const onPostpone = useCallback(() => {
        window.setTimeout(() => {
            dispatch({ type: SET_RELOAD_BROWSER_DIALOG_STATUS, payload: true })
        }, 120000)

        dispatch({ type: SET_RELOAD_BROWSER_DIALOG_STATUS, payload: false })
    }, [dispatch])

    return (
        <Dialog open={open} onClose={() => {}}>
            <AppDialogTitle text="Confirmation" />
            <DialogContent>
                Some important setting has been changed. We strongly recommend
                to reload to ensure all functionalities remain working properly.
            </DialogContent>
            <DialogActions>
                <Stack direction="row" spacing={2}>
                    <Button
                        color="primary"
                        onClick={() => window.location.reload()}
                    >
                        Reload immediately
                    </Button>
                    <Button onClick={onPostpone}>
                        Remind me again in 2 minutes
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    )
}

export default ReloadBrowserDialog
